import * as theme from "../../types/admin/themeTypes";
export const initialTheme = {
  info: {
    colorPrimary: "#f16444",
    borderRadius: "40",
    themeColor: "default",
    fontFamily: "'Inter', sans-serif",
    fontFamilyTitle: "'Exo2', sans-serif",
    language: "en",
    newConfig: {
      state: "initialTheme",
      colorSecondary: "hsl(11deg 86% 4% / 1)",
      colorPrimaryShades: [
        "#fff5f0",
        "#fff1eb",
        "#ffd3c2",
        "#ffb399",
        "#ff8f70",
        "#f16444",
        "#cc462f",
        "#a62e1e",
        "#801a11",
        "#590f0b",
      ],
      colorSecondaryShades: [
        "#404040",
        "#333333",
        "#262626",
        "#1a1a1a",
        "#0d0d0d",
        "#000000",
        "#000000",
        "#000000",
        "#000000",
        "#000000",
      ],
      colorText: "hsl(11deg 86% 4% / 1)",
      profileDropDownSecondaryBackground: "hsl(11deg 86% 61% / 0.04)",
      backgroundHover: "rgb(0 0 0 / 4%)",
      backgroundAccentColor: "hsl(11deg 86% 61% / 0.04)",
      algorithm: {},
      dashboardBackgroundColor: "hsl(11deg 86% 4% / 1)0d",
      tooltipBg: "hsl(11deg 86% 4% / 1)",
      boxShadow: "1px 1px 20px 6px hsl(11deg 86% 61% / 0.08)",
      theme: "default",
      colorPrimary: "#f16444",
      colorBgBase: "white",
      bubbleBackground: "rgb(0 0 0 / 8%)",
      secondaryBackground: "rgb(0 0 0 / 4%)",
      color: "black",
      color2: "white",
      breadcrumbsColor: "#757575",
      anchorColor: "#260b3b",
      colorHover: "white",
      cardBoxShadow: "1px 1px 11px rgba(149, 149, 149, 0.16)",
      cardborder: "solid 1px #e0dcd9",
      cardBlur: "0px",
      cardBackground: "white",
      scrollBarBg: "#f5f4f6",
      scrollBarBorder: "rgb(230, 230, 230)",
      scrollTrackBg: "rgb(230, 230, 230)",
      scrollTrackBorder: "rgb(230, 230, 230)",
      drawerbackDropBlur: "5px",
      drawerbackGround: "white",
      cursorSelectedbg: "#260b3b",
      cursorSelectedColor: "white",
      backdropColor: "rgb(0 0 0 / 14%)",
      backdropBlur: "2px",
      dashboardBackground: "",
      titleFontSize: "clamp(10px,.9vw,16px)",
      titleSecondaryFontSize: "clamp(10px,1.2vw,20px)",
      paraFontSize: "clamp(8px, 0.8vw, 14px)",
      btnFontSize: "clamp(8px, 0.8vw, 14px)",
      tableFontSize: "clamp(8px, 0.78vw, 12px)",
      tablePaddingSize: "clamp(4px, 0.4vw, 12px)",
      paraSecondaryFontSize: "clamp(8px, 0.7vw, 12px)",
      fontLgSize: "32px",
      fontMediumSize: "clamp(12px,1.5vw, 24px)",
      emptyStateSizes: {
        small: "133",
        medium: "200",
        large: "250",
      },
      fontSmlSize: "clamp(10px, 1vw, 16px)",
      tooltipColor: "grey",
      tooltipBgColor: "white",
      components: {
        Table: {
          colorBgContainer: "white",
          bodySortBg: "rgb(255, 255, 255)",
          expandIconBg: "rgb(255, 255, 255)",
          filterDropdownBg: "rgb(255, 255, 255)",
          fixedHeaderSortActiveBg: "rgb(255, 255, 255)",
          filterDropdownMenuBg: "rgb(255, 255, 255)",
          footerBg: "rgb(255, 255, 255)",
          headerBg: "rgb(255, 255, 255)",
          headerFilterHoverBg: "rgb(255, 255, 255)",
          headerSortActiveBg: "rgb(255, 255, 255)",
          headerSortHoverBg: "rgb(255, 255, 255)",
          rowHoverBg: "rgb(255, 255, 255)",
          cellFontSize: "clamp(8px, 0.78vw, 12px)",
          cellFontSizeMD: "clamp(8px, 0.78vw, 12px)",
          cellFontSizeSM: "clamp(8px, 0.78vw, 12px)",
          cellPaddingBlockSM: "clamp(4px, 0.4vw, 12px)",
          headerColor: "rgba(0, 0, 0, 0.88)",
          rowSelectedHoverBg: "rgba(255, 255, 255, 0)",
          colorText: "rgb(38, 11, 59)",
          colorTextDescription: "rgb(38, 11, 59)",
          colorTextHeading: "rgb(38, 11, 59)",
          fontSize: 12,
          fontWeightStrong: 400,
          algorithm: true,
        },
        Button: {
          defaultBg: "white",
        },
        Modal: {
          contentBg: "white",
          footerBg: "white",
          headerBg: "white",
        },
        Drawer: {
          colorBgElevated: "white",
        },
        Breadcrumb: {
          fontSize: "clamp(8px, 0.7vw, 12px)",
          itemColor: "rgb(0, 0, 0)",
          lastItemColor: "rgba(0, 0, 0, 0.88)",
          colorText: "rgb(0, 0, 0)",
          linkColor: "rgb(0, 0, 0)",
          separatorColor: "rgb(0, 0, 0)",
        },
        Card: {
          padding: 25,
          headerFontSize: "clamp(10px,.9vw,16px)",
          headerHeight: 50,
          fontWeightStrong: 400,
          boxShadowCard: "1px 1px 11px rgba(149, 149, 149, 0.16)",
          boxShadowTertiary: "0px 8px 24px rgba(149, 149, 149, 0.16)",
          colorBgContainer: "white",
          colorBorderSecondary: "#f5f4f6",
        },
        Progress: {
          defaultColor: "#f16444",
        },
        Select: {
          colorBgContainer: "white",
          controlHeight: 40,
          controlHeightLG: 48,
          algorithm: true,
        },
        Input: {
          controlHeight: 40,
          paddingBlock: 10,
          controlHeightLG: 48,
          algorithm: true,
        },
        Typography: {
          fontSizeHeading1: 38,
          fontSizeHeading2: 30,
          fontSizeHeading3: 24,
          fontSizeHeading4: 20,
          fontSizeHeading5: 16,
          fontWeightStrong: 500,
          algorithm: true,
          colorLink: "#260b3b",
        },
        DatePicker: {
          colorBgContainer: "white",
          colorBgElevated: "white",
          controlHeight: 40,
          controlHeightLG: 48,
          algorithm: true,
          sizePopupArrow: 0,
        },
        InputNumber: {
          colorBgContainer: "white",
          controlHeight: 40,
          controlHeightLG: 48,
        },
        FloatButton: {
          controlItemBgHover: "#f16444",
        },
        Layout: {
          bodyBg: "none",
        },
        Timeline: {
          dotBg: "rgba(255, 254, 254, 0)",
        },
        Checkbox: {
          colorBgContainer: "rgba(255, 255, 255, 0)",
        },
        Radio: {
          buttonBg: "rgba(255, 255, 255, 0)",
          colorBgContainer: "rgba(255, 255, 255, 0)",
          colorText: "black",
        },
        Segmented: {},
        Popover: {
          sizePopupArrow: 0,
          fontWeightStrong: 500,
          colorBgElevated: "white",
          colorText: "black",
        },
        Tooltip: {
          paddingSM: 20,
          paddingXS: 20,
          sizePopupArrow: 0,
          colorBgSpotlight: "white",
          colorBgElevated: "white",
          colorBgContainer: "white",
        },
        Badge: {
          colorBgContainer: "white",
        },
      },
    },
  },
};

export const themeReducer = (state = initialTheme, action) => {
  const { type, payload } = action;
  switch (type) {
    case theme.THEME_REQUEST:
      return {
        ...state,
        info: { ...state?.info, ...payload },
        loading: true,
      };
    case theme.THEME_SUCCESS:
      return {
        ...state,
        loading: false,
        info: { ...state?.info, ...payload },
        error: "",
      };
    case theme.THEME_FAIL:
      return {
        ...state,
        loading: false,
        error: { ...payload },
        info: { ...state?.info },
      };
    default:
      return state;
  }
};
export const themeCreateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case theme.CREATE_THEME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case theme.CREATE_THEME_SUCCESS:
      return {
        ...state,
        loading: false,
        info: { ...state?.info, ...payload },
        error: "",
      };
    case theme.CREATE_THEME_STOP_LOADING:
      return {
        ...state,
        loading: false,
        info: { ...state?.info },
        error: "",
      };
    case theme.CREATE_THEME_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const breadCrumbsReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case theme.CRUMB_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case theme.CRUMB_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case theme.CRUMB_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const toggleDrawerReducer = (state = { toggleValue: false }, action) => {
  const { type, payload } = action;

  switch (type) {
    case theme.TOGGLE_DRAWER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case theme.TOGGLE_DRAWER_SUCCESS:
      return {
        ...state,
        loading: false,
        toggleValue: payload, // Update the state with the DRAWER value
      };
    case theme.TOGGLE_DRAWER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};
